// import the library
import {library} from '@fortawesome/fontawesome-svg-core';

// import your icons

import {
  faGithub,
  faLinkedinIn,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
// import {faDizzy} from '@fortawesome/free-solid-svg-icons';
// import {faDizzy as dizzyRegular} from '@fortawesome/free-regular-svg-icons';

library.add(faLinkedinIn, faGithub, faTwitter);
//   faCode,
//   faHighlighter
// more icons go here
